import {FC} from 'react';
import {PageFooter} from './PageFooter';
import {PageHeader} from './PageHeader';

type LayoutProps = {
    withFooter?: boolean;
    withHeaderBorder?: boolean;
};

export const Layout: FC<LayoutProps> = ({children, withFooter = true, withHeaderBorder = false}) => (
    <>
        <PageHeader withHeaderBorder={withHeaderBorder} />
        {children}
        {withFooter && <PageFooter />}
    </>
);
